



































































import { Component, Vue, Watch } from 'vue-property-decorator';

/**
 * API
 */
import eventsAPI from "@/api/events";

/**
 * Utils
 */
import { getFullName } from "@/utils/users-helpers";
import { sortByAsc, sortByDesc } from "@/utils/sort-helpers";

/**
 * Mixins
 */
import mixinsDate from "@/mixins/date-mixins";

/**
 * Components
 */

/**
 * Types
 */
import { FilterModel } from '@/components/_global/FilterControl.vue';

const padMonth = (month: number) => {
	return ("0" + (month + 1)).slice(-2);
};


/**
 * Page de l'historique des consommations.
 */
@Component({ mixins: [mixinsDate] })
export default class EventsListPage extends Vue {
	/** Injections */
	getFullName = getFullName;

	/** Attibuts */
	isLoading = false;
	events: any[] = [];
	pagination = {
		sortBy: 'date',
		descending: true,
	};
	headers = [
		{
			text: 'event.date',
			value: 'date',
			align: 'left'
		},
		{
			text: 'event.label',
			value: 'label',
			align: 'left'
		},
		{
			text: 'event.service',
			value: 'service.label',
			align: 'left'
		},
		{
			text: 'event.user',
			value: 'user.firstName',
			align: 'left'
		},
		{
			text: 'event.amount',
			value: 'amount',
			align: 'right'
		},
		{
			text: '',
			value: null,
			align: 'right'
		},
	];
	filterModel: FilterModel | null = null;

	showMenu: any = {};
	isMenuLoading: any = {};
	currentEventSales: any[] | null = null;

	get filtersDefinitions() {
		return {
			0: {
				label: this.$t('event.user'),
				value: (x: any) => this.getFullName(x),
				key: 'id',
				items: this.events.reduce((acc, curr) => [...acc, curr.user], []).sort(sortByAsc((x) => this.getFullName(x))),
				f: (keySelected: string) => (x: any) => x.user.id === keySelected
			},
			1: {
				label: this.$t('event.service'),
				value: 'label',
				key: 'id',
				items: this.events.reduce((acc, curr) => [...acc, curr.service], []).sort(sortByAsc((x) => x.label)),
				f: (keySelected: string) => (x: any) => x.service.id === keySelected
			},
			2: {
				label: this.$t('event.month'),
				value: (x: any) => x.value,
				key: 'key',
				items: this.events.reduce((acc, curr) => {
					const date = new Date(Date.parse(curr.date));
					const month = padMonth(date.getMonth());
					const year = date.getFullYear();
					const monthKey = `${year}-${month}`;
					const monthValue = `${month}/${year}`;
					return [...acc, {
						key: monthKey,
						value: monthValue
					}];
				}, []).sort(sortByAsc((x) => x.key)),
				f: (keySelected: string) => (x: any) => {
					const yearMonthTab = keySelected.split("-");
					const year = yearMonthTab[0];
					const month = yearMonthTab[1];
					const date = new Date(Date.parse(x.date));
					return padMonth(date.getMonth()) === month && date.getFullYear().toString() === year;
				}
			}
		};
	}

	get displayedEvents() {
		return this.filterModel ? this.events.filter(this.filterModel.predicate) : this.events;
	}

	/** Méthodes */
	async created() {
		this.isLoading = true;
		this.events = await eventsAPI.getAll();
		this.isLoading = false;
	}

	async handleMoreClick(id: number) {
		this.isMenuLoading[id] = true;
		this.showMenu = {};
		this.currentEventSales = await eventsAPI.getSalesOfOne(id);
		this.showMenu[id] = true;
		this.isMenuLoading[id] = false;
	}
}
